import React, { useState, useEffect } from 'react';
import './manageDistrict.css';
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import districtService from '../../features/district/districtService';
import Tooltip from '@mui/material/Tooltip';
import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import FormHelperText from '@mui/material/FormHelperText';

import Spinner from "../Layout/Spinner";
import * as ld from 'lodash';

import { toast } from 'react-toastify';

function ManageDistrict() {
    let [open, setOpenAdd] = React.useState(false);
    let [isLoading, setIsLoading] = useState(false);
    let [countylist, setCounties] = useState([]);
    let [selectedAddCounty, setSelectedAddCounty] = useState('');
    let [selectedDistrict, setSelectedDistrict] = useState([]);
    let [selectedCountyMD, setselectedCountyMD] = useState('');
    let [selectedCountyNameMD, setselectedCountyNameMD] = useState('');
    let [districtlist, setDistricts] = useState([]);
    let [districtAddlist, setAddDistricts] = useState([]);
    let [allDcData, setAllDcData] = useState([]);
    let [selectedApproveStatus, setSelectedApproveStatus] = useState('');

    // Function to get county name from county id
    const getCountyNameFromId = (countyId) => {
        const selectedCounty = countylist.find(county => county._id === countyId);
        return selectedCounty ? selectedCounty.name : '';
    };


    const addDashboardDialog = () => {
        if (selectedCountyMD) {
            setOpenAdd(true);
            clearAddDistrictsFields();
        } else {
            toast.error("Please select county");
        }
    };

    let addDashboardClose = () => {
        setOpenAdd(false);
        clearAddDistrictsFields();
    };


    const [openEdit, setOpenEdit] = useState([]);

    const editDistrictDialog = (row) => {
        console.log("Row :" + row.countyDistId);
        setcountydistID(row.countyDistId)
        setOpenEdit({ id: row._id });
        setDistrictName(row.name);
        setFundedUpdatedValue(row.directlyFunded == '1' ? 'Yes' : 'No');
    };

    const closeEditDialog = () => {
        setOpenEdit(false);
    };

    const updateDistrictData = (editDistrict) => {
        console.log("editDistrict :" + editDistrict);
        const formData = {
            county: selectedCountyMD,
            districtId: editDistrict ? editDistrict._id : '',
            countydistID: editDistrict.countydistID,
            name: districtName ? districtName : editDistrict.name,
            directlyFunded: fundedUpdatedValue ? fundedUpdatedValue : editDistrict
        };

        try {
            setIsLoading(true);
            districtService.editUpdateddistrict(formData)
                .then((response) => {
                    setIsLoading(false);
                    if (response) {
                        toast.success(response.data.message ? response.data.message : "Error in submiting the data");
                        setOpenEdit(false);
                        fetchDistrictData(); //Added Newly
                        clearAddDistrictsFields()
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.error(error);
                    toast.error(error.message ? error.message : "Error in submiting the data");
                    setOpenEdit(false);
                });

        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching data:', error);
            toast.error(error.data.message ? error.data.message : "Error in submiting the data");
            setOpenAdd(false);
        }
    };

    let [openDelete, setOpenDelete] = React.useState([]);

    let deleteDistrictDialog = (districtID, districtName) => {
        setOpenDelete({ id: districtID, name: districtName });
    };

    let deleteDashboardClose = () => {
        setOpenDelete(false);
    };

    const [district_data, setDistrictData] = useState([]);
    const [school, setSchoolData] = useState([]);

    useEffect(() => {
        if (selectedCountyMD) {
            setIsLoading(true);
            fetchDistrictData();
        }
    }, [selectedCountyMD]);

  
    const fetchDistrictData = async () => {
        try {
            setIsLoading(true)
            const response = await districtService.getdistrictPageData(selectedCountyMD);
            const fetchedData = response.data;
             // Sort the district data by name alphabetically
            const sortedDistrictData = fetchedData.district.sort((a, b) => a.name.localeCompare(b.name));

            setDistrictData(sortedDistrictData);
            setSchoolData(fetchedData.school);
            setIsLoading(false);

        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
        }
    };

    const getSchoolDataForDistrict = (districtId) => {
        const schoolCount = school.filter(school => school.schoolData.some(data => data.district === districtId)).length;
        return schoolCount;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
        return date.toLocaleDateString('en-US', options).replace(/\//g, '-');
    };

    const constructJSONObject = () => {
        
        return district_data.map(district => {
            //const result = district.academicYear && district.academicYear.includes('6a20078bf78cc62472d2f8ea') ? 'yes' : 'no';
            const result = (district.academicYear && district.academicYear.length === 1 && district.academicYear[0] === '6a20078bf78cc62472d2f8ea') ? 'yes' : 'no';
            return {
                _id: district._id,
                name: district.name,
                countyDistId: district.districtData.find(data => data.academicYear === '6a20078bf78cc62472d2f8ea')?.cntydistid || '',
                county: district.county.name,
                directlyFunded:  district.districtData[0]?.directlyFunded,
                creationDate: formatDate(district.creationDate),
                academicYear: result,
                schoolCount: getSchoolDataForDistrict(district._id),
            };
        });
    };

    const jsonDistrictData = constructJSONObject();

    let onCountySelect = (e) => {
        console.log("*************** Selected County Name *******************")
        console.log(e.target.value)
        setselectedCountyMD(e.target.value);
        localStorage.setItem('selectedCountyMD', e.target.value); //Added Newly 23/05/2024
        setSelectedDistrict('');
        selectedDistrict = '';
        let dcdata = allDcData;
        if (e.target.value == "") {
            localStorage.removeItem("countyfilterValue");
            localStorage.removeItem("districtfilterValue");
            setSelectedDistrict('');
            setDistricts([]);
        }

        if (e.target.value != "") {
            localStorage.setItem('countyfilterValue', e.target.value);
            dcdata = dcdata.filter((user) => {
                return user.countyId == e.target.value;
            });
        }
        if (e.target.value != "") {
            console.log("*************** Selected County Name Value 1 *******************")
            console.log(e.target.value)
            if (selectedDistrict != "") {
                dcdata = dcdata.filter((user) => {
                    return user.districtId == selectedDistrict;
                });
            }
        }
    };

    useEffect(() => {
        axios.get(config.basePath + 'common/getCountyList')
            .then((response) => {
                let data = response.data;
                setCounties(data.length > 0 ? ld.orderBy(data, [item => item.name.toLowerCase()], ['asc']) : data);
            })
            .catch((error) => console.error(error));
    }, []);

    let [districtName, setDistrictName] = useState('');
    let [countydistID, setcountydistID] = useState('');
    const [error, setError] = useState('');
    let [fundedValue, setFundedValue] = useState('No');
    let [fundedUpdatedValue, setFundedUpdatedValue] = useState('');

    let onFundedSelect = (fund) => {
        setFundedValue(fund.target.value)
    }

    let onFundedEditSelect = (fund) => {
        setFundedUpdatedValue(fund.target.value)
    }

    const onDistrictInputChange = (event) => {
        setDistrictName(event.target.value);
    };

    const oncountydistIDInputChange = (event) => {
        const value = event.target.value;

        if (value.length !== 7 && value.length !== 14) {
            setError('CountyDistrict ID must be either 7 or 14 characters long.');
            setcountydistID(value)
        }else {
            setError('')
            setcountydistID(value)
        }
    }

    const showErrorMessage = () => {
        toast.error("The district cannot modify or delete as it doesn't belong to the current academic year.");
    }

    const saveDistrictData = async () => {
        if (countydistID.length !== 7 && countydistID.length !== 14) {
            setError('CountyDistrict ID must be either 7 or 14 characters long.');
            return;
        }
        const formData = {
            county: selectedCountyMD,
            name: districtName,
            countyDistId: countydistID,
            subscriptionStartDate: null,
            subscriptionEndDate: null,
            directlyFunded: fundedValue === 'Yes' ? fundedValue : 'No'
        };

        try {
            setIsLoading(true);
            districtService.addNewdistrict(formData)
                .then((response) => {
                    setIsLoading(false);
                    if (response) {
                        toast.success(response.data.message ? response.data.message : "Error in submiting the data");
                        setOpenAdd(false);
                        clearAddDistrictsFields();
                        fetchDistrictData();
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.error(error);
                    toast.error(error.message ? error.message : "Error in submiting the data");
                    setOpenAdd(false);
                });
        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching data:', error);
            toast.error(error.data.message ? error.data.message : "Error in submiting the data");
            setOpenAdd(false);
        }
    };

    const clearAddDistrictsFields = () => {
        setcountydistID("");
        setDistrictName("");
        setFundedValue("")
    }

    const [filterValue, setFilterValue] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const handleFilterChange = (event) => {
        const value = event.target.value;
        setFilterValue(value);

        const filtered = district_data.filter((item) =>
            item.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredData(filtered);
    };

    const handleDeleteDistrict = (districtId) => {
        districtService.deletedistrict(districtId)
            .then((response) => {
                setIsLoading(false);
                if (response) {
                    toast.success(response.data.message ? response.data.message : "Error in submiting the data");
                    setOpenDelete(true);
                    fetchDistrictData();  //Added Newly
                    clearAddDistrictsFields()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error(error);
                toast.error(error.message ? error.message : "Error in submiting the data");
                setOpenDelete(false);
            });
    };

    const handleYearSelection = () => {
        toast.error("Restricted in historical data view");
      };

    return (
        <>
            {(isLoading === true) ? <Spinner></Spinner> : ""}
            <div className='mgndistrict_pageHeader'>
                <div className="pageText">Manage Districts</div>
            </div>
            <div className='pageContent'>
                <div className='mDist_UserDetails'>
                    <div className='mDist_countyDetails'>
                        <FormControl className="text-inside-grid" variant="standard" sx={{ minWidth: 400 }}>
                            <InputLabel id="selectCountyId">Select County</InputLabel>
                            <Select
                                labelId="selectCountyId"
                                id="selectCounty"
                                value={selectedCountyMD}
                                onChange={onCountySelect}
                                label="Country"
                                MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}>
                                <MenuItem value="" >
                                    SELECT COUNTY
                                </MenuItem>
                                {countylist.map((county) => (
                                    <MenuItem key={county._id} value={county._id}>
                                        {county.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    {localStorage.getItem('academicyear') === 'currentyear' && (
                    <Tooltip title='Add District' placement="top-start">
                        <div className='mDist_addDashUser'>
                            <span>
                                <Fab size="small" color="primary" aria-label="add" className='mDist_addButton' mattooltip="Add District" onClick={() => addDashboardDialog()} >< AddBusinessIcon /></Fab>
                            </span>
                        </div>
                    </Tooltip>
                    )}
                    <Dialog
                        open={open}
                        sx={{
                            "& .MuiDialog-container": {
                                "& .MuiPaper-root": {
                                    width: "100%",
                                    maxWidth: "400px",
                                },
                            },
                        }}
                        onClose={addDashboardClose}
                        aria-labelledby="addDashboardLabel"
                        aria-describedby="addDashboardDescription"
                    >
                        <DialogTitle id="addDashboardTitle">
                            ADD DISTRICT
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="addDashboardDescription">
                                <form>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="selectedCountyMD"
                                        label="County Name"
                                        type="text"
                                        value={getCountyNameFromId(selectedCountyMD)}
                                        disabled
                                        fullWidth
                                        variant="standard"
                                        inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: "#9E9E9E !important" } }}
                                        InputLabelProps={{ style: { fontSize: 13, width: '100%', paddingLeft: '5px', paddingBottom: '5px', paddingTop: '5px', color: '#9E9E9E' } }}
                                        sx={{
                                            marginTop: '0px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px",
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#9E9E9E",
                                            }
                                        }}
                                    />

                                    <div className='mDist_districtDetails'>
                                        <TextField
                                            label="District Name"
                                            value={districtName}
                                            onChange={onDistrictInputChange}
                                            variant="standard"
                                            inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }}
                                            InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }}
                                            sx={{ marginTop: '20px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px", minWidth: 350, minHeight: 15 }}

                                        />
                                    </div>
                                    <div className='mDist_districtDetails'>
                                        <TextField
                                            label="CountyDistrict ID"
                                            value={countydistID}
                                            onChange={oncountydistIDInputChange}
                                            variant="standard"
                                            inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }}
                                            InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }}
                                            sx={{ marginTop: '20px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px", minWidth: 350, minHeight: 15 }}
                                            error={!!error}
                                        />
                                         {error && (
                                            <FormHelperText error>
                                            {error}
                                            </FormHelperText>
                                        )}
                                    </div>

                                    <FormControl className="text-inside-grid" variant="standard" sx={{ minWidth: 350, minHeight: 15 }}>
                                        <InputLabel id="fundedLabel" sx={{ zIndex: 1, margin: '20px 0px 0px 4px', fontSize: '13px', color: '#000000 !important' }}>Funded</InputLabel>
                                        <Select
                                            labelId="fundedLabel"
                                            id="fundedLabelId"
                                            // variant="standard"
                                            label="Funded"
                                            sx={{ marginTop: '30px', fontSize: '13px', padding: '10px 0px 0px 5px', backgroundColor: '#eeeeee', height: '45px', borderRadius: "5px 5px 0px 0px", minWidth: 350 }}
                                            inputProps={{ style: { fontSize: '13px', width: '100%', height: '400px', padding: '5px', color: '#000000' } }}
                                            InputLabelProps={{ style: { fontSize: '13px', width: '100%', height: '400px', padding: '5px', color: '#000000', marginTop: '24px' } }}
                                            value={fundedValue || 'No'}
                                            onChange={onFundedSelect}>
                                            <MenuItem value="No">No</MenuItem>
                                            <MenuItem value="Yes">Yes</MenuItem>
                                        </Select>
                                    </FormControl>
                                </form>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions className="mDist_popupactionButton">
                            <Button variant="contained" className="mDist_save_button" onClick={saveDistrictData}>Save</Button>
                            <Button variant="contained" onClick={addDashboardClose} className="mDist_cancel_button" autoFocus> Cancel </Button>
                        </DialogActions>
                    </Dialog>
                </div>

                <div className='mDist_filterInput'>
                    <Box
                        component="form"
                        sx={{
                            '& > :not(style)': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <TextField
                            id="mDist_filterInpText"
                            label="FILTER"
                            variant="standard"
                            value={filterValue}
                            onChange={handleFilterChange}
                        />
                    </Box>
                </div>
                {selectedCountyMD ?
                    <div className='mDist_userTable'>
                        <TableContainer component={Paper} sx={{ height: "60vh" }}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" className='mDist_tableHeader'>DISTRICT</TableCell>
                                        <TableCell align="left" className='mDist_tableHeader'>FUNDED</TableCell>
                                        <TableCell align="left" className='mDist_tableHeader'>COUNTYDISTID</TableCell>
                                        <TableCell align="left" className='mDist_tableHeader'>CREATION DATE</TableCell>
                                        <TableCell align="left" className='mDist_tableHeader'>NUMBER OF SCHOOLS</TableCell>
                                        <TableCell align="left" className='mDist_tableHeader'>ACTIONS</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filterValue === '' ?
                                        jsonDistrictData.map((row) => (
                                            <TableRow
                                                key={row.name}
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                            >
                                                <TableCell align="left" className='mDist_tableBody mDist_email_column'>{row.name}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody mDist_date_column'>{row.directlyFunded == '0' ? 'No' : 'Yes'}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody mDist_date_column'>{row.countyDistId}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody mDist_date_column'>{row.creationDate}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody mDist_date_column row_center'>{getSchoolDataForDistrict(row._id)}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody'>
                                                    <div className="mDist_actionButton">

                                                        {row.academicYear === 'no' ? (
                                                            <a href="#" onClick={localStorage.getItem("academicyear") === 'currentyear' ? () => showErrorMessage() : () => handleYearSelection()} style={{ cursor: localStorage.getItem("academicyear") === 'currentyear' ? 'not-allowed' : 'pointer' }}>
                                                                <img alt="Edit District" src={require("../../assets/images/editDC_new.png")} mattooltip="Edit user details" className="mDist_action_imge" />
                                                            </a>
                                                        ) :
                                                            <Tooltip title='Edit District' placement="top-start">
                                                                <a href="#" onClick={localStorage.getItem("academicyear") === 'currentyear' ? () => editDistrictDialog(row) : () => handleYearSelection()}>
                                                                    <img alt="Edit District" src={require("../../assets/images/editDC_new.png")} mattooltip="Edit user details" className="mDist_action_imge"></img>
                                                                </a>
                                                            </Tooltip>
                                                        }

                                                        <Dialog
                                                            open={openEdit.id === row._id}
                                                            onClose={closeEditDialog}
                                                            aria-labelledby="editDistrictTitle"
                                                            aria-describedby="editDistrictDescription"
                                                            sx={{
                                                                "& .MuiDialog-container": {
                                                                    "& .MuiPaper-root": {
                                                                        width: "100%",
                                                                        maxWidth: "400px",
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <DialogTitle id="editDistrictTitle">
                                                                EDIT DISTRICT
                                                            </DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText id="editDistrictDescription">
                                                                    <form>
                                                                        <TextField
                                                                            autoFocus
                                                                            margin="dense"
                                                                            id="selectedCountyMD"
                                                                            label="County Name"
                                                                            type="text"
                                                                            value={getCountyNameFromId(selectedCountyMD)}
                                                                            disabled
                                                                            fullWidth
                                                                            variant="standard"
                                                                            inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: "#9E9E9E !important" } }}
                                                                            InputLabelProps={{ style: { fontSize: 13, width: '100%', paddingLeft: '5px', paddingBottom: '5px', paddingTop: '5px', color: '#9E9E9E' } }}
                                                                            sx={{
                                                                                marginTop: '0px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px",
                                                                                "& .MuiInputBase-input.Mui-disabled": {
                                                                                    WebkitTextFillColor: "#9E9E9E",
                                                                                }
                                                                            }}
                                                                        />

                                                                        <TextField
                                                                            autoFocus
                                                                            margin="dense"
                                                                            id="selectedCountyDistMD"
                                                                            label="County District Id"
                                                                            type="text"
                                                                            value={countydistID}
                                                                            disabled
                                                                            fullWidth
                                                                            variant="standard"
                                                                            inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: "#9E9E9E !important" } }}
                                                                            InputLabelProps={{ style: { fontSize: 13, width: '100%', paddingLeft: '5px', paddingBottom: '5px', paddingTop: '5px', color: '#9E9E9E' } }}
                                                                            sx={{
                                                                                marginTop: '15px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px",
                                                                                "& .MuiInputBase-input.Mui-disabled": {
                                                                                    WebkitTextFillColor: "#9E9E9E",
                                                                                }
                                                                            }}
                                                                        />

                                                                        <div className='mDist_districtDetails'>
                                                                            <TextField
                                                                                label="District Name"
                                                                                value={districtName}
                                                                                // value={districtName ? districtName : row.name} 
                                                                                onChange={(e) => setDistrictName(e.target.value)}
                                                                                variant="standard"
                                                                                inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }}
                                                                                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }}
                                                                                sx={{ marginTop: '20px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px", minWidth: 350, minHeight: 15 }}
                                                                            />
                                                                        </div>

                                                                        <FormControl className="text-inside-grid" variant="standard" sx={{ minWidth: 350, minHeight: 15 }}>
                                                                            <InputLabel id="fundedLabel" sx={{ zIndex: 1, margin: '20px 0px 0px 4px', fontSize: '13px', color: '#000000 !important' }}>Funded</InputLabel>
                                                                            <Select
                                                                                labelId="fundedLabel"
                                                                                id="fundedLabelId"
                                                                                label="Funded"
                                                                                sx={{ marginTop: '30px', fontSize: '13px', padding: '10px 0px 0px 5px', backgroundColor: '#eeeeee', height: '45px', borderRadius: "5px 5px 0px 0px", minWidth: 350 }}
                                                                                inputProps={{ style: { fontSize: '13px', width: '100%', height: '400px', padding: '5px', color: '#000000' } }}
                                                                                InputLabelProps={{ style: { fontSize: '13px', width: '100%', height: '400px', padding: '5px', color: '#000000', marginTop: '24px' } }}
                                                                                value={fundedUpdatedValue ? fundedUpdatedValue : row.directlyFunded}
                                                                                onChange={onFundedEditSelect}                                                                         
                                                                            >
                                                                                <MenuItem value="No">No</MenuItem>
                                                                                <MenuItem value="Yes">Yes</MenuItem>
                                                                            </Select>
                                                                        </FormControl>

                                                                    </form>
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions className="mDist_popupactionButton">
                                                                <Button variant="contained" onClick={() => updateDistrictData(row)} className="mDist_save_button" >Update</Button>
                                                                <Button variant="contained" onClick={closeEditDialog} className="mDist_cancel_button" autoFocus>Cancel</Button>
                                                            </DialogActions>
                                                        </Dialog>

                                                        {row.academicYear === 'no' ? (
                                                            <a href="#" onClick={localStorage.getItem("academicyear") === 'currentyear' ? () => showErrorMessage() : () => handleYearSelection()} style={{ cursor: 'not-allowed' }}>
                                                                <img alt="Delete district" src={require("../../assets/images/deleteDC_new.png")} className="mDist_action_imge" />
                                                            </a>
                                                        ) :
                                                            <Tooltip title='Delete District' placement="top-start">
                                                                <a href="#" onClick={localStorage.getItem("academicyear") === 'currentyear' ? () => deleteDistrictDialog(row._id, row.name) : () => handleYearSelection()}>
                                                                    <img alt="Delete district" src={require("../../assets/images/deleteDC_new.png")} mattooltip="Delete user details" className="mDist_action_imge" />
                                                                </a>
                                                            </Tooltip>
                                                        }

                                                        <Dialog
                                                            open={openDelete.id === row._id}
                                                            aria-labelledby="deleteDashboardLabel"
                                                            aria-describedby="deleteDashboardDescription"
                                                        >
                                                            <DialogTitle id="deleteDashboardTitle">
                                                                Delete District
                                                            </DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText id="deleteDashboardDescription">
                                                                    <div>
                                                                        {/* Do you want delete the <b>{openDelete.name}</b> District? */}
                                                                        Are you sure you would like to delete <b>{openDelete.name}</b>? The district was added on  <b>{row.creationDate}</b>.
                                                                    </div>
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions className="mDist_popupactionButton">
                                                                <Button variant="contained" onClick={() => handleDeleteDistrict(row._id)} className="mDist_save_button" >Delete</Button>
                                                                <Button variant="contained" onClick={() => deleteDashboardClose(row._id)} className="mDist_cancel_button" autoFocus> Cancel </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                        :
                                        filteredData.map((row) => (
                                            <TableRow
                                                key={row.name}
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                            >
                                                <TableCell align="left" className='mDist_tableBody mDist_email_column'>{row.name}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody mDist_date_column'>{row.districtData[0].directlyFunded == '0' ? 'No' : 'Yes'}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody mDist_date_column'>{row.countyDistId}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody mDist_date_column'>{formatDate(row.creationDate)}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody mDist_date_column row_center'>{getSchoolDataForDistrict(row._id)}</TableCell>
                                                <TableCell align="left" className='mDist_tableBody'>
                                                    <div className="mDist_actionButton">
                                                        {row.academicYear.lenth !== 1 && row.academicYear != '6a20078bf78cc62472d2f8ea' ? (
                                                            <a href="#" onClick={localStorage.getItem("academicyear") === 'currentyear' ? () => showErrorMessage() : () => handleYearSelection()} style={{ cursor: 'not-allowed' }}>
                                                                <img alt="Edit District" src={require("../../assets/images/editDC_new.png")} mattooltip="Edit user details" className="mDist_action_imge"></img>
                                                            </a>
                                                        ) : 
                                                            <a href="#" onClick={localStorage.getItem("academicyear") === 'currentyear' ? () => editDistrictDialog(row) : () => handleYearSelection()}>
                                                                <img alt="Edit District" src={require("../../assets/images/editDC_new.png")} mattooltip="Edit user details" className="mDist_action_imge"></img>
                                                            </a>
                                                        }

                                                        <Dialog
                                                            open={openEdit.id === row._id}
                                                            onClose={closeEditDialog}
                                                            aria-labelledby="editDistrictTitle"
                                                            aria-describedby="editDistrictDescription"
                                                            sx={{
                                                                "& .MuiDialog-container": {
                                                                    "& .MuiPaper-root": {
                                                                        width: "100%",
                                                                        maxWidth: "400px",
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <DialogTitle id="editDistrictTitle">
                                                                EDIT DISTRICT
                                                            </DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText id="editDistrictDescription">
                                                                    <form>
                                                                        <TextField
                                                                            autoFocus
                                                                            margin="dense"
                                                                            id="selectedCountyMD"
                                                                            label="County Name"
                                                                            type="text"
                                                                            value={getCountyNameFromId(selectedCountyMD)}
                                                                            disabled
                                                                            fullWidth
                                                                            variant="standard"
                                                                            inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: "#9E9E9E !important" } }}
                                                                            InputLabelProps={{ style: { fontSize: 13, width: '100%', paddingLeft: '5px', paddingBottom: '5px', paddingTop: '5px', color: '#9E9E9E' } }}
                                                                            sx={{
                                                                                marginTop: '0px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px",
                                                                                "& .MuiInputBase-input.Mui-disabled": {
                                                                                    WebkitTextFillColor: "#9E9E9E",
                                                                                }
                                                                            }}
                                                                        />

                                                                        <div className='mDist_districtDetails'>
                                                                            <TextField
                                                                                label="District Name"
                                                                                value={districtName}
                                                                                // value={districtName ? districtName : row.name}
                                                                                onChange={(e) => setDistrictName(e.target.value)}
                                                                                variant="standard"
                                                                                inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }}
                                                                                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }}
                                                                                sx={{ marginTop: '20px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px", minWidth: 350, minHeight: 15 }}
                                                                            />
                                                                        </div>

                                                                        <FormControl className="text-inside-grid" variant="standard" sx={{ minWidth: 350, minHeight: 15 }}>
                                                                            <InputLabel id="fundedLabel" sx={{ zIndex: 1, margin: '20px 0px 0px 4px', fontSize: '13px', color: '#000000 !important' }}>Funded</InputLabel>
                                                                            <Select
                                                                                labelId="fundedLabel"
                                                                                id="fundedLabelId"
                                                                                label="Funded"
                                                                                sx={{ marginTop: '30px', fontSize: '13px', padding: '10px 0px 0px 5px', backgroundColor: '#eeeeee', height: '45px', borderRadius: "5px 5px 0px 0px", minWidth: 350 }}
                                                                                inputProps={{ style: { fontSize: '13px', width: '100%', height: '400px', padding: '5px', color: '#000000' } }}
                                                                                InputLabelProps={{ style: { fontSize: '13px', width: '100%', height: '400px', padding: '5px', color: '#000000', marginTop: '24px' } }}
                                                                                // value={row.directlyFunded == '0' ? 'No' : 'Yes'}
                                                                                // value={fundedValue ? fundedValue : row.directlyFunded}
                                                                                // onChange={onFundedSelect}
                                                                                value={fundedUpdatedValue ? fundedUpdatedValue : row.directlyFunded}
                                                                                onChange={onFundedEditSelect}
                                                                            >
                                                                                <MenuItem value="No">No</MenuItem>
                                                                                <MenuItem value="Yes">Yes</MenuItem>
                                                                            </Select>
                                                                        </FormControl>

                                                                    </form>
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions className="mDist_popupactionButton">
                                                                <Button variant="contained" onClick={() => updateDistrictData(row)} className="mDist_save_button" >Update</Button>
                                                                <Button variant="contained" onClick={closeEditDialog} className="mDist_cancel_button" autoFocus>Cancel</Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                        {row.academicYear.length !== 1 && row.academicYear != '6a20078bf78cc62472d2f8ea' ? (
                                                            <a href="#" onClick={localStorage.getItem("academicyear") === 'currentyear' ? () => showErrorMessage() : () => handleYearSelection()} style={{ cursor: 'not-allowed' }}>
                                                                <img alt="Delete District" src={require("../../assets/images/deleteDC_new.png")} mattooltip="Delete user details" className="mDist_action_imge"></img>
                                                            </a>
                                                        ) :
                                                            <a href="#" onClick={localStorage.getItem("academicyear") === 'currentyear' ? () => deleteDistrictDialog(row._id, row.name) : () => handleYearSelection()}>
                                                                <img alt="Delete District" src={require("../../assets/images/deleteDC_new.png")} mattooltip="Delete user details" className="mDist_action_imge"></img>
                                                            </a>
                                                        }
                                                        <Dialog
                                                            open={openDelete.id === row._id}
                                                            aria-labelledby="deleteDashboardLabel"
                                                            aria-describedby="deleteDashboardDescription"
                                                        >
                                                            <DialogTitle id="deleteDashboardTitle">
                                                                Delete DASHBOARD USER
                                                            </DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText id="deleteDashboardDescription">
                                                                    <div>
                                                                        Delete Dashboard User from 'Malcolm X Elementary' school in 'Alameda' County and 'Berkeley Unified' District
                                                                    </div>
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions className="mDist_popupactionButton">
                                                                <Button variant="contained" onClick={() => handleDeleteDistrict(row._id)} className="mDist_save_button" >Delete</Button>
                                                                <Button variant="contained" onClick={() => deleteDashboardClose(row._id)} className="mDist_cancel_button" autoFocus> Cancel </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div> : ""
                }
            </div>


        </>
    )
}

export default ManageDistrict